import compareModelsReducer from "./compareModelsReducer";
import autosuggestReducer from "./autosuggestReducer";
import { combineReducers } from "redux";
const rootReducer = combineReducers({
  compare: compareModelsReducer,
  autosuggest: autosuggestReducer
});

export default rootReducer;
